/**
 * Map translations to object
 * @param {Array} translationsArray
 * @description Creates an object with the translated values from the translationsArray array.
 * @returns {Object}
 */

const mapTranslationsToObject = translationsArray =>
  translationsArray.reduce((acc, { key, value }) => {
    acc[key] = value

    return acc
  }, {})

export default mapTranslationsToObject
